// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from "react";
// semantic-ui
import { Menu, Loader, Dropdown } from "semantic-ui-react";

// store
import { observer } from "mobx-react";
import { store } from "services/state";

// utilities
import Sidebar from "components/Sidebar/Sidebar";
import MenuLink from "components/MenuLink";
import { getFilteredApis, resetSwaggerApiName } from "utils/function-utils";
export default observer(
  class ApisMenu extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpenDropdown: false,
      };
    }

    getApiGroupList(currentHost) {
      const allApis = [].concat(
        store.apiList.apiGateway,
        store.apiList.generic
      );
      const filteredApiList = getFilteredApis(allApis, currentHost);
      const { MES, Version, Active, Stage, ApiGatewayVersion } = currentHost;
      const apiGroupList = filteredApiList.map((api) => {
        const apiName = resetSwaggerApiName(
          MES,
          api.swaggerApiName,
          Version,
          ApiGatewayVersion,
          Active
        );
        return {
          generic: api.generic || false,
          title: apiName,
          id: api.id,
          stage: api.stage || (Stage && Stage.toLowerCase()),
          path: api.generic
            ? `/apis/${api.id}`
            : `/apis/${api.id}/${api.stage}`,
        };
      });
      return apiGroupList;
    }

    getHostOptions(apiList) {
      return apiList
        .map((host) => {
          return {
            key: host.Host,
            text: host.Name,
            value: host.Host,
            hostid: host.Host,
            host: host.Host,
          };
        })
        .filter((host) => host.key);
    }

    getSelectedApi(path, apiGroupList) {
      let selectedApi;
      if (path.url === "/apis") {
        selectedApi = apiGroupList.length && apiGroupList[0].path;
      } else {
        selectedApi = path.url;
      }
      return selectedApi;
    }

    getDefaultValue(hostOptions, currentHost) {
      return hostOptions.find((host) => host.hostid === currentHost.Host).value;
    }

    render() {
      const { changeOptions, loaded, currentHost, apiList, path } = this.props;
      const { isOpenDropdown } = this.state;
      if (!loaded || !store.apiList.loaded) {
        return <Loader active />;
      }
      const apiGroupList = this.getApiGroupList(currentHost);
      if (!apiGroupList.length) {
        return (
          <p style={{ padding: "13px 16px", color: "whitesmoke" }}>
            No APIs Published
          </p>
        );
      }
      const hostOptions = this.getHostOptions(apiList);
      const selectedApi = this.getSelectedApi(path, apiGroupList);
      const defaultValue = this.getDefaultValue(hostOptions, currentHost);
      return (
        <Sidebar id="apis-menu-sidebar">
          <Dropdown
            icon={isOpenDropdown ? "angle up" : "angle down"}
            onOpen={() => this.setState({ isOpenDropdown: true })}
            onClose={() => this.setState({ isOpenDropdown: false })}
            fluid
            selection
            options={hostOptions}
            defaultValue={defaultValue}
            onChange={changeOptions}
          />
          <>
            {apiGroupList.map(({ id, stage, path, title }) => (
              <MenuLink key={id} active={selectedApi === path}>
                {title}
                <Menu.Menu>
                  <MenuLink
                    key={id}
                    to={path}
                    active={selectedApi === path}
                    style={{ fontWeight: "400" }}
                  >
                    {stage}
                  </MenuLink>
                </Menu.Menu>
              </MenuLink>
            ))}
          </>
        </Sidebar>
      );
    }
    // If we're still loading, display a spinner.
    // If we're not loading, and we don't have any apis, display a message.
    // If we're not loading, and we have some apis, render the appropriate api subsections for apiGateway and generic apis
  }
);
